import React, { Component } from "react";
import ServicesHeader from "../elements/services-header";

//Elements
import Help from "../elements/help";
import DamageFeaturesSection from "../elements/feature-bx-damage";

class DamageInspection extends Component {
  render() {
    return (
      <>
        <ServicesHeader title="Skadebesiktning"></ServicesHeader>;
        <div className="section-area section-sp1">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-5">
                <DamageFeaturesSection />
              </div>
              <div className="col-lg-4 col-md-5">
                <aside className="sticky-top pb-1">
                  <Help></Help>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default DamageInspection;
